module.exports = __webpack_public_path__ + "static/about-ffd0ee83e2b021113976787f438f45b3.jpg";